import React from "react";




import { Checkbox, Form } from "rsuite";

export default (props) => {
    return <Form.Group>
        <Form.Control
            name={props.name}
            accepter={CheckboxHOC}
            {...props}
        />
    </Form.Group>;
};

export const CheckboxHOC = ({ value, checked, inverse, onChange, ...props }) => {
    const controlledChecked = typeof value === "boolean" ? value : checked;
    const handleChange = (_, nextChecked) => onChange(inverse ? !nextChecked : nextChecked);

    return <Checkbox
        {...props}
        {...(typeof controlledChecked === "boolean" ? { checked: controlledChecked } : {})}
        onChange={handleChange}
    />;
};
